import { deleteHttp } from "../../../common/api/apiShared";
import { DeleteEntityTemplateStepDialogProps } from "./DeleteEntityTemplateStepDialog.tsx";
import { useDotLegalSnackbar } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "../../../localization/useTranslation.ts";
import { useDotLegalMutation } from "@common/hooks/dotLegalReactQuery";
import { DeletionResult } from "../../EntityTemplate.types.ts";

export function useDeleteEntityTemplateStepDialog(props: DeleteEntityTemplateStepDialogProps) {
    const snackbar = useDotLegalSnackbar();
    const { translateString } = useTranslation();

    const deleteMutation = useDotLegalMutation(deleteEntityTemplateStepApi);
    const onDeleteStep = () => {
        deleteMutation.mutateAsync(undefined, {
            onSuccess: (response) => {
                const deletion = response.value();
                if (deletion?.isDeleted === false) {
                    snackbar.show(translateString("stepFieldsUsedInOtherFields", { names: deletion.name }), "warning");
                    props.onCloseDialog();
                } else {
                    snackbar.show(translateString("templateStepDeleted"));
                    props.onStepDeleted();
                }
            },
        });
    };

    return {
        isDeleting: deleteMutation.isLoading,
        onDeleteStep,
    };

    function deleteEntityTemplateStepApi() {
        return deleteHttp<DeletionResult>(`/entity-templates/${props.entityTemplateId}/steps/${props.stepId}`);
    }
}
